import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  configurationPaper: {
    padding: theme.spacing(3),
  },
}));
